<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { useRegistrationDocumentTypesStore } from '@/stores/registration_documents_types'

const { t } = useI18n();
const registerStore = useRegisterStore();
const documentTypeStore = useRegistrationDocumentTypesStore();

const getDocumentType = () => {
	return documentTypeStore.getRegistrationDocumentTypeById(registerStore.register_input_fields.registration_document_id_type);
}
</script>

<template>
	<div class="register-form-field">
			<label>{{$t('account.register.document_number')}}</label>
			<div v-if="getDocumentType() === 'ecowas_identify_card'" class="input-wrapper">
				<div class="form-input">
					<p>GHA</p>
				</div>
				<input class="form-input" :placeholder="$t('account.register.document_number')" @keyup="registerStore.validateDocumentNumber" v-model="registerStore.register_input_fields.document_id_number" type="text"
					name="full_name" required="required" />
			</div>
			<input v-else class="form-input" :placeholder="$t('account.register.document_number')" @keyup="registerStore.validateDocumentNumber" v-model="registerStore.register_input_fields.document_id_number" type="text"
					name="full_name" required="required" />
			<div class="register-form-list" v-if="registerStore.register_errors.document_id_number.error">
				<div class="password-meter">
					<div class="password-meter-bar">
						<div class="password-meter-bar-inn"></div>
					</div>
				</div>
				<p>
					<img src="@/assets/svgs/cross.svg" alt=""/>
					&nbsp;
					<span v-if="registerStore.register_errors.document_id_number.error == 'error_only_characters_and_numbers'">
						{{ $t('account.register.error_only_characters_and_numbers') }}
					</span>
					<span v-else-if="registerStore.register_errors.document_id_number.error === 'error_document_id_number_required'">
						{{ $t('account.register.error_document_id_required') }}
					</span>
					<span v-else-if="registerStore.register_errors.hasOwnProperty('document_id_number')">
						{{ registerStore.register_errors.document_id_number.error }}
					</span>
				</p>
			</div>
	</div>
</template>

<style scoped>

.input-wrapper {
	display: grid;
    grid-template-columns: 20% 1fr;
    gap: 5px;
}

.form-input p {
	font-size: 13px;
	color: var(--white)
}
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>
